import { useSelector } from 'react-redux'
import { userSelector } from '../../../store/session'
import { useMemo } from 'react'

export const withRoleAccess = (WrappedComponent) => {
  return function WithRoleAccess({ allowedRoles, ...rest }) {
    const { user } = useSelector(userSelector)
    const userRole = useMemo(() => user?.role?.type, [user])

    const hasAccess = () => user && allowedRoles && allowedRoles.some((role) => role === userRole)
    return hasAccess() && <WrappedComponent {...rest} />
  }
}
